// extracted by mini-css-extract-plugin
module.exports = {"Button":"NavAuthButtons_Button__2hshP","ButtonWhite":"NavAuthButtons_ButtonWhite__cRFo4","Transparent":"NavAuthButtons_Transparent__13NUY"};